module.exports = __webpack_public_path__ + "static/media/surveyLogo.fc297bc3.png";